import { Badge, Button, InputAdornment, Stack, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Iconify from '../iconify/Iconify';
import { TABLE_TOUCH_TARGET_SIZE } from './responsiveColumns';

const TableActionsRenderer = ({
  Actions,
  searchable,
  filterable,
  table,
  onSearch,
  fetching = false,
}) => {
  // O valor local mantem a digitacao fluida e preserva a normalizacao aplicada pelo wrapper.
  // O atraso antes da consulta pertence a `useTableFilter`, nao a esta toolbar.
  const [searchValue, setSearchValue] = useState(table.search || '');

  useEffect(() => {
    setSearchValue(table.search || '');
  }, [table.search]);

  const handleChangeSearch = (event) => {
    setSearchValue(event.target.value);
    if (onSearch) {
      onSearch(event.target.value);
    }
  };

  return (
    <Stack
      p={2}
      mb={1}
      direction="row"
      flexWrap="wrap"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
    >
      {searchable && (
        <TextField
          sx={{
            flex: {
              xs: 1,
              sm: 'unset',
            },
          }}
          size="small"
          placeholder="Pesquisar"
          value={searchValue}
          onChange={handleChangeSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                data-testid={fetching ? 'table-search-loading' : 'table-search-icon'}
              >
                <Iconify icon={fetching ? 'eos-icons:loading' : 'ion:search-outline'} />
              </InputAdornment>
            ),
          }}
        />
      )}
      <Stack
        width={{
          xs: 1,
          sm: 'unset',
        }}
        direction={{
          xs: 'column',
          sm: 'row',
        }}
        alignItems={{
          xs: 'stretch',
          sm: 'center',
        }}
        gap={1}
        justifyContent={{
          xs: 'flex-start',
          sm: 'flex-end',
        }}
        sx={{
          '& > *': {
            flex: {
              xs: 1,
              sm: 'unset',
            },
          },
        }}
      >
        {Array.isArray(Actions)
          ? Actions.map((action, index) => <div key={`action-${index}`}>{action}</div>)
          : Actions}
        {filterable && (
          <Badge badgeContent={table.dirtyFilters} color="primary">
            <Button
              fullWidth
              variant="outlined"
              onClick={() => table.setShowFilter(true)}
              startIcon={<Iconify icon="eva:options-2-outline" />}
              color="inherit"
              // O medium do tema tem 36px, abaixo do alvo de toque de 44px. Abaixo do `sm` o
              // botão ocupa a linha inteira, então a altura extra não desalinha vizinho; do
              // `sm` para cima volta ao tamanho do tema (CKTPL-1612).
              sx={{ minHeight: { xs: TABLE_TOUCH_TARGET_SIZE, sm: 'auto' } }}
            >
              Filtros
            </Button>
          </Badge>
        )}
      </Stack>
    </Stack>
  );
};

TableActionsRenderer.propTypes = {
  Actions: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  searchable: PropTypes.bool,
  filterable: PropTypes.bool,
  table: PropTypes.object,
  onSearch: PropTypes.func,
  fetching: PropTypes.bool,
};

export default TableActionsRenderer;
